import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProjectService } from '../../shared/services/project.service';
import { Subscription } from 'rxjs';
import { IProjectProposalDetails } from '../../shared/models/project-proposal-details';
import { IApiResponse } from '../../../../shared/models/api-response';

@Component({
    selector: 'app-project-proposal-details',
    templateUrl: './project-proposal-details.component.html',
    styleUrl: './project-proposal-details.component.scss',
    standalone: false
})
export class ProjectProposalDetailsComponent implements OnInit, OnDestroy  {
  @Input() salesforceId: string | null = null;

  projectProposalDetails: IProjectProposalDetails | null = null;
  loading = false;
  private subscriptions = new Subscription();

  constructor(private _projectService: ProjectService) {}

  ngOnInit(): void {
    this.getProjectProposalDetails();
  }


  getProjectProposalDetails() {
    this.loading = true;
    if (!this.salesforceId || this.salesforceId.trim() === '') {
      console.warn('Salesforce Id is missing. Skipping API call.');
      this.loading = false;
      return;
    }

    const subscription = this._projectService
      .getProjectProposalDetails(this.salesforceId || '')
      .subscribe({
        next: (response: IApiResponse<IProjectProposalDetails>) => {
          if (response.success) {
            this.projectProposalDetails = response.content;
          }
          this.loading = false;
        },
        error: err => {
          console.error('Error fetching project proposal details:', err);
          this.loading = false;
        },
      });

    this.subscriptions.add(subscription);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
